import React from 'react';
import { CheckCircle, Download, Smartphone, Lock, CreditCard, ShieldCheck } from 'lucide-react';
export function TrustBadges() {
  const badges = [{
    icon: CheckCircle,
    text: 'Acceso inmediato'
  }, {
    icon: Download,
    text: 'Descarga digital'
  }, {
    icon: Smartphone,
    text: 'Compatible con todos tus dispositivos'
  }, {
    icon: Lock,
    text: 'Pago 100% seguro'
  }, {
    icon: CreditCard,
    text: 'Hasta 3 cuotas sin interés'
  }, {
    icon: ShieldCheck,
    text: 'Garantía de 7 días'
  }];
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8 max-w-4xl mx-auto" data-id="element-69">
      {badges.map((badge, index) => <div key={index} className="flex items-center gap-3 bg-green-50/50 p-3 rounded-lg border border-green-100" data-id="element-70">
          <badge.icon className="w-5 h-5 text-[#4CAF50] flex-shrink-0" data-id="element-71" />
          <span className="text-sm font-medium text-gray-700" data-id="element-72">
            {badge.text}
          </span>
        </div>)}
    </div>;
}